import React from "react";
import { useTranslation } from "react-i18next";
import InfoBannerCst from "@components/InfoBannerCst";

const EditorialBanner: React.FC = () => {
  const { t } = useTranslation("wizard-activity");

  return (
    <InfoBannerCst>
      <strong>{t("editorial.banner.title")}</strong>
      <br />
      {t("editorial.banner.description")}
    </InfoBannerCst>
  );
};

export default EditorialBanner;
